export const richMediaId = '60acc41970bee4615fb3e5c6'; // 1x1
export const richMediaNoVerticalId = '60d44daac8fdd4212327cc01'; // 1x1
export const static300x250Id = '60acc42070bee4615fb3e5c8'; // 300x250
export const static728x90Id = '60acc43170bee4615fb3e5cc'; // 728x90
export const dynamic300x50Id = '60acc44c4ddc61657bcb531b'; // 300x50 | 320x50
export const dynamic300x250Id = '60acc42a70bee4615fb3e5ca'; // 300x250 | 300x600 | 160x600
export const dynamic970x250Id = '60acc43970bee4615fb3e5ce'; // 728x90 | 970x250 | 970x90
